import baseAPI from '@/api';
import { PaginatedResponse } from '@/models/pagination/paginated-response.dto';
import { DetailedUserReward } from '@/models/user-reward/detailed';
import { QueryFunctionContext } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { UserRewardsMeQueryKey } from './props';

export async function fetchUserRewardsMe({
  queryKey,
}: QueryFunctionContext<UserRewardsMeQueryKey>): Promise<
  PaginatedResponse<DetailedUserReward>
> {
  const filter = queryKey[1];
  try {
    const response: AxiosResponse<PaginatedResponse<DetailedUserReward>> =
      await baseAPI.get<PaginatedResponse<DetailedUserReward>>(
        '/user-rewards/me',
        {
          params: filter,
        },
      );

    return response.data;
  } catch (error) {
    return null;
  }
}
